// extracted by mini-css-extract-plugin
export default {"advertCardFooter":"c-a_jb","advertCardFooter__row":"c-a_jc","advertCardFooter__name":"c-a_je","advertCardFooter__price":"c-a_jf","advertCardFooter__age":"c-a_jg"};